import DonateButton from '../layout/DonateButton';
import HeaderButton from './HeaderButton';
import SocialMediaButtons from './SocialMediaButtons';
import WhiteLogo from '../../assets/images/inspira_logo_white.svg';
import { Link } from 'react-router-dom';


export default function Header() {
    return (
        <header className="bg-idarkblue shadow-sm sticky top-0 z-50 w-full overflow-x-hidden">
            <div className="container lg:px-4 py-3 flex lg:justify-around justify-between items-center w-full">
                {/* Desktop Navigation */}
                <div className="hidden lg:flex space-x-10">
                    <HeaderButton idSection='team-section' buttonText={'¿Quiénes somos?'} />
                    <HeaderButton idSection='our-work' buttonText={'Proyectos'} />
                    <HeaderButton idSection='support-section' buttonText={'¿Cómo puedo apoyar?'} />
                    <DonateButton />
                </div>

                {/* Mobile: Logo + Social Media */}
                <div className="flex items-center space-x-4 lg:hidden justify-start ml-7">
                    <Link to="/">
                        <img src={WhiteLogo} alt="Inspira Logo" className="h-6 mx-auto mt-3" />
                    </Link>
                    <SocialMediaButtons />
                </div>


                {/* Desktop: Social Media */}
                <div className="hidden lg:flex space-x-4">
                    <SocialMediaButtons />
                </div>
            </div>
        </header>
    );
}
